/* eslint-disable eqeqeq */
/* eslint-disable @typescript-eslint/strict-boolean-expressions */
import ApiUtils from 'api/ApiUtils';
import React from 'react';
import {Button, Col, Form, Row} from 'react-bootstrap';
import {useFormik} from 'formik';

import * as Yup from 'yup';
import {toast} from 'react-toastify';
import TooltipWithInfoIcon from 'Common/InfoTool';
import {tooltipMessage} from 'utils/Tooltips';
import {type BookTableFormProps} from 'utils/TypeConfig';
const BookTableForm: React.FC<BookTableFormProps> = ({
  handleClose,
  // setIsEditCategory,
  setIsEditBookTable,
  setIsAddCategory,
  editBookTable,
}) => {
  console.log('🚀 ~ editBookTable:', editBookTable, editBookTable?.status);
  // const [status, setStatus] = useState();

  // const getStatusOptions = (currentStatusId: number): any => {
  //   switch (currentStatusId) {
  //     case 1: // Received
  //       return IS_REQUEST.filter(status => status.id === 2 || status.id === 4);
  //     case 2: // Confirmed
  //       return IS_REQUEST.filter(status => status.id === 4);
  //     case 3: // Request for Reject
  //       return IS_REQUEST.filter(status => status.id === 4);
  //     case 4: // Cancelled
  //       return []; // No statuses to show
  //     default:
  //       return []; // Fallback for unexpected status
  //   }
  // };

  const bookStatus = [
    {
      id: 2,
      title: 'Confirmed',
    },
    {
      id: 4,
      title: 'Cancelled',
    },
  ];
  // Example usage
  const guestStatus = bookStatus;
  // getStatusOptions(editBookTable?.status);
  console.log('🚀 ~ guestStatus:', guestStatus);

  // useEffect(() => {
  //   const fetchStatus = async (): Promise<void> => {
  //     try {
  //       const queryParams = 'type=category';
  //       const response: any = await ApiUtils.getStatus(queryParams);
  //       setStatus(response.data);
  //     } catch (err) {
  //       console.error(err);
  //     }
  //   };

  //   void fetchStatus();
  // }, []);

  const validation: any = useFormik({
    enableReinitialize: true,
    initialValues: {
      status:
        editBookTable?.status !== '' && editBookTable?.status !== 1
          ? editBookTable?.status
          : '',
    },
    validationSchema: Yup.object({
      status: Yup.number().required('Status is required'),
    }),
    onSubmit: async (values: any): Promise<void> => {
      console.log('🚀 ~ onSubmit: ~ values:', values);

      try {
        const formData = {
          status: parseInt(values.status),
          ...(editBookTable?.id ? {id: editBookTable?.id} : {}),
        };

        if (typeof values?.image !== 'string') {
          (formData as any).image = values?.image;
        }

        try {
          // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
          const response: any = editBookTable?.id
            ? await ApiUtils.updateBookTableStatus(formData)
            : await ApiUtils.addCategory(formData);
          // eslint-disable-next-line @typescript-eslint/no-floating-promises, @typescript-eslint/strict-boolean-expressions
          if (setIsEditBookTable) {
            setIsEditBookTable((prev: boolean) => !prev);
          }
          if (setIsAddCategory) {
            setIsAddCategory((prev: boolean) => !prev);
          }
          handleClose();
          toast.success(response?.message);
          // void getCategoryList();
        } catch (error: any) {
          toast.error(error?.response?.data?.message);
        }
      } catch (err: any) {
        toast.error(err);
      }
    },
  });

  console.log('validation', validation.values.status);

  // console.log(editBookTable?.id, 'categoryList');
  return (
    <div>
      <Form
        className="tablelist-form"
        onSubmit={e => {
          e.preventDefault();
          validation.handleSubmit();
        }}>
        <Row>
          <div
            id="alert-error-msg"
            className="d-none alert alert-danger py-2"></div>
          <input type="hidden" id="id-field" />

          <Col lg={12}>
            <div className="mb-3">
              <div className="d-flex">
                <Form.Label htmlFor="status-Field">Status</Form.Label>

                <TooltipWithInfoIcon text={tooltipMessage.CategoryStatus} />
              </div>
              <Form.Select
                className="form-select"
                name="status"
                id="status-Field"
                onChange={e =>
                  validation.setFieldValue('status', e.target.value)
                }
                value={
                  validation.values.status ||
                  (editBookTable?.status !== '' ? editBookTable?.status : '')
                }
                isInvalid={
                  !!(validation.touched.status && validation.errors.status)
                }>
                <option value="">--Select Status--</option>
                {guestStatus?.map((status: any, i: number) => (
                  <option key={i} value={status.id}>
                    {status.title}
                  </option>
                ))}
              </Form.Select>

              {Boolean(validation.touched.status) &&
              Boolean(validation.errors.status) ? (
                <Form.Control.Feedback className="required-mark" type="invalid">
                  {validation.errors.status}
                </Form.Control.Feedback>
              ) : null}
            </div>
          </Col>

          <Col lg={12} className="modal-footer">
            <div className="hstack gap-2 justify-content-end">
              <Button
                role="submitCategory"
                variant="dark"
                id="add-btn"
                type="submit">
                {editBookTable?.id !== undefined
                  ? 'Update Status'
                  : 'Add Event'}
              </Button>
            </div>
          </Col>
        </Row>
      </Form>
    </div>
  );
};

export default BookTableForm;
